<template>
  <reference-filter-multiple-select
    label="Full Text Review Status"
    :options="options"
    :selected-values.sync="selectedModel"
  />
</template>

<script>
import ReferenceFilterMultipleSelect from './ReferenceFilterMultipleSelect';
import { AssessmentStatusFilter } from '@/enums';

const HAS_FULL_TEXT_PDF = 'HAS_FULL_TEXT_PDF';

const ASSESSMENT_STATUS_FILTER_TO_OPTION = {
  [HAS_FULL_TEXT_PDF]: 'Uploaded Full Text PDF',
  [AssessmentStatusFilter.NO_ASSESSMENTS]: 'No reviews',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT]:
    'Awaiting a review',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT_BY_YOU]:
    'Awaiting a review by you',
  [AssessmentStatusFilter.ASSESSMENTS_BY_YOU]: 'Reviews by you',
  [AssessmentStatusFilter.INCLUDE_ASSESSMENT_BY_YOU]:
    'Included by you',
  [AssessmentStatusFilter.EXCLUDE_ASSESSMENT_BY_YOU]:
    'Excluded by you',
  [AssessmentStatusFilter.CONFLICTED]: 'Conflicted',
  [AssessmentStatusFilter.INCLUDE_OUTCOME]: 'Included',
  [AssessmentStatusFilter.EXCLUDE_OUTCOME]: 'Excluded',
};

export default {
  name: 'ReferenceFilterFullTextReviewStatus',
  components: { ReferenceFilterMultipleSelect },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    hasFullTextPdf: {
      type: Boolean,
      default: undefined,
    },
  },
  emits: ['update:selected', 'update:hasFullTextPdf'],
  computed: {
    selectedModel: {
      get() {
        if (this.hasFullTextPdf) {
          return [...this.selected, HAS_FULL_TEXT_PDF];
        }
        return this.selected;
      },
      set(value) {
        const hasFullTextPdf =
          value?.includes(HAS_FULL_TEXT_PDF) || undefined;
        if (this.hasFullTextPdf !== hasFullTextPdf) {
          this.hasFullTextPdfModel = hasFullTextPdf;
        } else {
          value = value?.filter((v) => v !== HAS_FULL_TEXT_PDF);
          this.$emit('update:selected', value);
        }
      },
    },
    hasFullTextPdfModel: {
      get() {
        return this.hasFullTextPdf;
      },
      set(value) {
        this.$emit('update:hasFullTextPdf', value);
      },
    },
    options() {
      return Object.keys(ASSESSMENT_STATUS_FILTER_TO_OPTION).map(
        (filter) => ({
          value: filter,
          label: ASSESSMENT_STATUS_FILTER_TO_OPTION[filter],
        })
      );
    },
  },
};
</script>
